import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'insurance-list-view',
  standalone: false,
  templateUrl: './insurance-list-view.component.html',
  styleUrl: './insurance-list-view.component.scss',
})
export class InsuranceListViewComponent {
  @Input() insurances: app.models.InsuranceModel[];
  @Input() props: app.models.DynamicPropsDictionary;

  public dictionaryRequestStatus = DictionaryRequestStatus;

  constructor(private _router: Router) {}

  navigateToDetailHandler(id: string) {
    this._router.navigate(['insurances', id]);
  }
}
